import React from 'react';
import { AmenityPriceData } from '../../types';

interface AmenityPremiumChartProps {
  data: AmenityPriceData[];
}

export const AmenityPremiumChart: React.FC<AmenityPremiumChartProps> = ({ data }) => {
  if (!data || data.length === 0) {
    return (
      <div className="amenity-chart-container">
        <h3>Prêmio/Desconto de Preço por Comodidade</h3>
        <div style={{ height: '400px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#a0aec0' }}>
          Nenhum dado de preço de comodidade disponível
        </div>
      </div>
    );
  }

  const series = data
    .filter((d) => !isNaN(d.diff) && isFinite(d.diff))
    .map((d) => ({
      amenity: d.amenity,
      value: Number(d.diff),
    }))
    .sort((a, b) => b.value - a.value);

  return (
    <div className="amenity-chart-container">
      <h3>
        Prêmio/Desconto de Preço por Comodidade ({series.length} comodidades)
      </h3>
      <table style={{ 
        width: '100%',
        borderCollapse: 'collapse',
        fontSize: '14px'
      }}>
        <thead>
          <tr style={{ 
            borderBottom: '2px solid #2d3748',
            textAlign: 'left'
          }}>
            <th style={{ padding: '8px', color: '#9AA8BD' }}>Comodidade</th>
            <th style={{ padding: '8px', textAlign: 'right', color: '#9AA8BD' }}>Impacto no Preço (R$/m²)</th>
          </tr>
        </thead>
        <tbody>
          {series.map((item, idx) => (
            <tr 
              key={idx}
              style={{ 
                borderBottom: '1px solid #2d3748',
                transition: 'background 200ms, transform 200ms',
                cursor: 'pointer'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = 'rgba(255, 255, 255, 0.05)';
                e.currentTarget.style.transform = 'scale(1.01)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = 'transparent';
                e.currentTarget.style.transform = 'scale(1)';
              }}
            >
              <td style={{ padding: '8px', color: '#EAEAEA' }}>{item.amenity}</td>
              <td style={{ 
                padding: '8px',
                textAlign: 'right',
                fontWeight: 'bold',
                color: item.value >= 0 ? '#27ae60' : '#e74c3c'
              }}>
                {item.value >= 0 ? '+' : ''}R${item.value.toFixed(1)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
